import { create } from "zustand";

interface DatabaseSyncWrapperState {
  refetchProjectsTrigger: number;
  refetchElementMetadataTrigger: number;
  refetchProjectLoadingProgressTrigger: number;
  refetchCanvasTrigger: number;
  refetchIssuesTrigger: number;
  triggerRefetchProjects: () => void;
  triggerRefetchElementMetadata: () => void;
  triggerRefetchProjectLoadingProgress: () => void;
  triggerRefetchCanvas: () => void;
  triggerRefetchIssues: () => void;
}

export const useDatabaseSyncWrapperStore = create<DatabaseSyncWrapperState>(
  (set) => ({
    refetchProjectsTrigger: 0,
    refetchElementMetadataTrigger: 0,
    refetchProjectLoadingProgressTrigger: 0,
    refetchCanvasTrigger: 0,
    refetchIssuesTrigger: 0,
    triggerRefetchProjects: () =>
      set((state) => ({
        refetchProjectsTrigger: state.refetchProjectsTrigger + 1,
      })),
    triggerRefetchElementMetadata: () =>
      set((state) => ({
        refetchElementMetadataTrigger: state.refetchElementMetadataTrigger + 1,
      })),
    triggerRefetchProjectLoadingProgress: () =>
      set((state) => ({
        refetchProjectLoadingProgressTrigger:
          state.refetchProjectLoadingProgressTrigger + 1,
      })),
    triggerRefetchCanvas: () =>
      set((state) => ({
        refetchCanvasTrigger: state.refetchCanvasTrigger + 1,
      })),
    triggerRefetchIssues: () =>
      set((state) => ({
        refetchIssuesTrigger: state.refetchIssuesTrigger + 1,
      })),
  }),
);
